import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/templates');

const shotsCalculateService = createService(httpClient, (client) => ({
    calculate(data: Record<string, unknown>): Promise<any> {
        return client.post('/shots/calculate', data);
    },
}));

export default shotsCalculateService;
